import { ReactElement } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Scholarship } from '@backrs_ui/common-ui/src/models/scholarship';

import { Box, Typography } from '@mui/material';

import { formatMoney } from './formatUtils';
import { largeTextGroupStyle } from './styles';

const { AWARD_INFO } = appStrings.modules.nugget.scholarship;

export function AwardInfo({ scholarshipInfo }: { scholarshipInfo: Scholarship }): ReactElement {
  const {
    award_money_range_min,
    award_money_range_max,
    submission_deadline,
    award_total_num_prev_year,
    award_category,
    description,
  } = scholarshipInfo;

  const awardRangeMin = formatMoney(award_money_range_min);
  const awardRangeMax = award_money_range_max ? ` - ${formatMoney(award_money_range_max)}` : '';

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" flexDirection="row" gap={4}>
        {(awardRangeMin || awardRangeMax) && (
          <Typography variant="body1" sx={largeTextGroupStyle}>
            <span style={highlightedBlueTextStyle}>{AWARD_INFO.AWARD_RANGE}</span> {awardRangeMin}
            {awardRangeMax}
          </Typography>
        )}
        {submission_deadline && (
          <Typography variant="body1" sx={largeTextGroupStyle}>
            <span style={highlightedBlueTextStyle}>{AWARD_INFO.APPLICATION_DEADLINE}</span>{' '}
            {submission_deadline}
          </Typography>
        )}
        {award_total_num_prev_year && (
          <Typography variant="body1" sx={largeTextGroupStyle}>
            <span style={highlightedBlueTextStyle}>{AWARD_INFO.PREVIOUS_YEAR}</span>{' '}
            {award_total_num_prev_year} {AWARD_INFO.AWARDS}
          </Typography>
        )}
      </Box>
      {award_category && (
        <Typography variant="body1" sx={largeTextGroupStyle}>
          <span style={highlightedBlueTextStyle}>{AWARD_INFO.AWARD_CATEGORY}</span>{' '}
          {scholarshipInfo.award_category}
        </Typography>
      )}
      {description && (
        <Typography variant="body1" sx={largeTextGroupStyle}>
          <span style={highlightedBlueTextStyle}>{AWARD_INFO.DESCRIPTION}</span>{' '}
          {scholarshipInfo.description}
        </Typography>
      )}
    </Box>
  );
}

const highlightedBlueTextStyle: React.CSSProperties = {
  fontWeight: 700,
  color: appColors.color.blue1,
};
